import { Box } from '@chakra-ui/react';
import { BenefitVerificationTable } from '@/components/Templates/BenefitVerification';

const BenefitsVerification = () => {
	return (
		<Box>
			<BenefitVerificationTable />
		</Box>
	);
};

export default BenefitsVerification;
